import React from "react";
import { useSortable } from "@dnd-kit/react/sortable";
import { PointerSensor } from "@dnd-kit/dom";
import { cn } from "@/shared/utils/shadcn";

export interface KanbanItemProps extends React.HTMLProps<HTMLDivElement> {
  id: string;
  columnId: string;
  order: number;
  data: any;
}

function KanbanItem(props: KanbanItemProps) {
  const { id, columnId, order } = props;
  const sensors = [
    PointerSensor.configure({
      activationConstraints: {
        distance: { value: 10 },
      },
    }),
  ];

  const { ref } = useSortable({
    id,
    index: order,
    group: columnId,
    type: "item",
    accept: "item",
    sensors,
  });

  return (
    <div className={cn("w-full py-2 cursor-pointer")} ref={ref}>
      {props.children}
    </div>
  );
}

export default KanbanItem;
